<script>
import * as boxType from '@/services/rest-api-vsms/lib/fleet/box-type'
import RestEditableTable from '@/components/RestEditableTable'
import McEmptyState from '@/components/McEmptyState'

const defaultFieldOpts = {
  editable: true,
  isSortable: true,
}

export default {
  components: {
    RestEditableTable,
    McEmptyState,
  },
  props: {
    status: String,
  },
  data() {
    return {
      isTableDataAvailable: true,
      fields: [
        {
          ...defaultFieldOpts,
          key: 'name',
          label: this.$t('setting.list.fleetSetting.boxType'),
          placeholder: 'Jenis Box',
          validation: 'required|max:64,length',
          type: 'text',
          'validation-messages': {
            required: this.$t('global.validation.required'),
            max: 'Nama jenis box tidak lebih dari 64 karakter',
          },
        },
        {
          ...defaultFieldOpts,
          key: 'weight_capacity',
          label: this.$t('setting.list.fleetSetting.capacity'),
          placeholder: 'Daya Angkut',
          validation: 'required|number|min:0,value|max:6,length',
          _type: 'number',
          'validation-messages': {
            required: this.$t('global.validation.required'),
            number: 'Invalid input',
            min: 'Minimum Daya Angkut tidak kurang dari 0 Kg',
            max: 'Jumlah daya angkut tidak lebih dari 6 digit',
          },
        },
        {
          ...defaultFieldOpts,
          key: 'volume_capacity',
          label: this.$t('setting.list.fleetSetting.volume'),
          placeholder: 'Volume Angkut',
          validation: 'required|number|min:0,value|max:6,length',
          _type: 'number',
          'validation-messages': {
            required: this.$t('global.validation.required'),
            number: 'Invalid input',
            min: 'Minimum Volume Angkut tidak kurang dari 0 Cbm',
            max: 'Jumlah volume angkut tidak lebih dari 6 digit',
          },
        },
      ],
      addData: false,
    }
  },
  methods: {
    getBoxType: boxType.get,
    showBoxType: boxType.show,
    updateBoxType: boxType.update,
    storeBoxType: boxType.store,
    deleteBoxType: boxType.deleteMany,
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      if (!this.isTableDataAvailable) this.addData = true

      setTimeout(() => {
        this.$refs.table.handleAdd()
      }, 400)
    },
    setStatus() {
      this.$store.commit('setting/SET_STATUS', this.status)
    },
  },
}
</script>

<template>
  <b-tab class="border-0" @click="setStatus">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.fleetSetting.boxType') }}</span>
    </template>

    <RestEditableTable
      v-show="isTableDataAvailable || addData"
      ref="table"
      searchable
      :fields="fields"
      :apiClient="{
        get: getBoxType,
        show: showBoxType,
        update: updateBoxType,
        store: storeBoxType,
        delete: deleteBoxType,
      }"
      trackBy="id"
      :bulkDeleteApi="true"
      @available-change="handleDataAvailable"
    />
    <div v-show="!isTableDataAvailable && !addData" class="empty-table-container">
      <McEmptyState
        class="pb-4"
        :title="$t('setting.list.fleetSetting.nothingBox')"
        :desc="$t('global.addNewData')"
        @buttonPrimaryAction="handleAdd"
      />
    </div>
  </b-tab>
</template>
